export enum SsoStatus {
  Unknown,
  Created,
  Linked,
  NotLinked,
  Locked,
  Error
}
